import React from 'react';
import Container from '@mui/material/Container';

const ExamplePage = () => (
    <Container maxWidth="md">
        <h1>Example Page</h1>
    </Container>
);

export default ExamplePage;